/*
import React          from "react";
import ReactDOM       from "react-dom";
import AppWrapper     from "./AppWrapper";

ReactDOM.render(
    <React.StrictMode>
        <AppWrapper />
    </React.StrictMode>
    , document.getElementById("root")
);
*/
import
    React
    , {
        StrictMode
        //, Fragment
    }
    from 'react';

import { createRoot } from 'react-dom/client';

//import ReactDOM from 'react-dom';
//import { BrowserRouter as Router, Route, Link, Switch, useParams } from 'react-router-dom';
//import { BrowserRouter } from 'react-router-dom';
//import './index.scss';
//import App from "./App";
import AppWrapper from "./AppWrapper";
//import * as serviceWorker from './serviceWorker';
//import { Provider } from 'react-redux';
//import store from './store'

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
    <StrictMode>
        <AppWrapper />
    </StrictMode>
);